import React from 'react';

import Row from 'components/Common/Row';
import Typography from 'kingpin/atoms/Typography';

/**
 * The header for a mode that transforms the board slideout in place
 * (overrides, recognition payments): "{title}: {driver}", an optional status
 * row of badges, then the mode's actions — Secondary first, Primary last.
 * Stacked so nothing squishes in the narrow (440px) slideout.
 */
const SlideOutModeHeader = ({
  title,
  driverName,
  status,
  actions,
}: {
  title: string;
  driverName?: string;
  status?: React.ReactNode;
  actions: React.ReactNode;
}) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      width: '100%',
    }}
  >
    <Typography.Header type={'H3'}>
      {driverName ? `${title}: ${driverName}` : title}
    </Typography.Header>
    {status && (
      <Row centerAlign style={{ gap: 8 }}>
        {status}
      </Row>
    )}
    <Row centerAlign style={{ gap: 8 }}>
      {actions}
    </Row>
  </div>
);

export default SlideOutModeHeader;
